import React from "react";
import Container from "../Layout/Container";
import { connect } from "react-redux";
import {
  getSmsItems,
  postSmsItem,
  deleteSmsItem,
  updateSmsItem,
  clearErrors
} from "../../redux/Actions/smsAction";
import SmsEditModal from "./Items/SmsEditModal";
import ContentBlock from "../Layout/ContentBlock";
import TableColumnSms from "./Items/TableColumnSms";
import FilterMenu from "../Layout/FilterMenu";
import TableFilterBox from "../common/TableFilterBox";
import ContentValidation from "../common/ContentValidation";
import PaginationComp from "../Dashboard/items/Pagination";

class SmsTemplate extends React.Component {
  constructor() {
    super();
    this.state = {
      requiredId: 0,
      page: 1,
      pageCount: 100,
      paramsFilter: "",
      action: "new",
    };
  }
  componentDidMount() {
    this.props.getSmsItems(this.state.page, this.state.pageCount);
  }
  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.page !== this.state.page ||
      prevState.pageCount !== this.state.pageCount
    ) {
      this.props.getSmsItems(this.state.page, this.state.pageCount);
    }
  }

  onAction = (action, index) => {
    this.setState({
      requiredId: index,
      action: action,
    });
  };

  setPagination = (page) => {
    this.setState({
      page,
    });
  };
  setPageCount = (pageCount) => {
    this.setState({
      pageCount,
      page: 1,
    });
  };

  render() {
    const requiredItem = this.state.requiredId;
    let modalData = this.props.smsItems[requiredItem]
      ? this.props.smsItems[requiredItem]
      : [];
    return (
      <Container
        location={{
          locationName: "Žinučių šablonai",
          locationUrl: this.props.match.url,
        }}
      >
        <ContentBlock>
          <FilterMenu
            length={`${this.props.totals || 0} / ${
              this.props.smsItems.length || 0
            }`}
            onChangeCountPage={this.setPageCount}
            countPage={this.state.pageCount}
            text="žinučių šablonų"
            text2="Žinučių šablonų"
          />
        </ContentBlock>
        <ContentBlock>
          <TableFilterBox filter={false} add={this.onAction}></TableFilterBox>
          <div>
            <ContentValidation
              loader={this.props.loading_sms}
              array={this.props.smsItems}
              alertId_s="smsAlert-s"
              alertId_e="smsAlert-e"
            >
              <div className="table-responsive">
                <table className="table table-sm table-hover mt-3">
                  <thead>
                    <tr className="text-muted">
                      <th className="text-black">#</th>
                      <th className="text-black">Pavadinimas</th>
                      <th className="text-black">Žinutė</th>
                      <th className="text-black">Identifikatorius</th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.smsItems.map((item, index) => {
                      return (
                        <TableColumnSms
                          key={index}
                          index={index}
                          id={item.id}
                          item={item}
                          onAction={this.onAction}
                          onDelete={this.props.deleteSmsItem}
                        />
                      );
                    })}
                  </tbody>
                </table>
                <PaginationComp
                  setPagination={this.setPagination}
                  page={this.state.page}
                  totals={this.props.totals}
                  pageCount={this.state.pageCount}
                />
              </div>
            </ContentValidation>
          </div>
        </ContentBlock>

        <SmsEditModal
          action={this.state.action}
          postSmsItem={this.props.postSmsItem}
          updateSmsItem={this.props.updateSmsItem}
          objectData={modalData}
          clearErrors={this.props.clearErrors}
          errors={this.props.errors}
        />
      </Container>
    );
  }
}
const mapStateToProps = (state) => ({
  smsItems: state.sms.smsItems,
  totals: state.sms.totals,
  loading_sms: state.sms.loading_sms,
  errors: state.errors,
});

export default connect(mapStateToProps, {
  getSmsItems,
  postSmsItem,
  deleteSmsItem,
  updateSmsItem,
  clearErrors
})(SmsTemplate);
